import React, { Component } from "react";
import "./register.css"
import Logo from "../../asset/images/Logo1.png"
import { Link } from "react-router-dom";
import Image from "../../asset/images/image1.jpeg"
import axios from "axios"

class AdminSignup extends Component {
    state = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        country: "",
        password: "",
        loading: false,
        error: "",
        success: ""
    }


    handleInput = (event) => {
        const { name, value } = event.target
        this.setState({
            [name]: value
        })
    }


    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true })

        const dataToSend = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phone: this.state.phone,
            country: this.state.country,
            password: this.state.password,
        };

        try {
            const response = await axios.post('https://teslasafebroker.com/api/admin/register', dataToSend);
            console.log('Registration successful:', response.data);
            this.setState({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                country: "",
                password: "",
            });
            if (response.data && response.data.message) {
                this.setState({ loading: false, success: response.data.message })
            }

        } catch (error) {
            let errorMessage = "Something went wrong, try again";
            let clearAfterDelay = false;

            if (error.response) {
                console.error('Server responded with error:', error.response.data);

                if (error.response.status === 500) {
                    // Keep default errorMessage
                } else {
                    errorMessage = error.response.data.message || "An error occurred";
                    clearAfterDelay = true;
                }

            } else if (error.request) {
                console.error('No response received:', error.request);
                // Keep default errorMessage
                clearAfterDelay = true;
            } else {
                console.error('Request setup error:', error.message);
                // Keep default errorMessage
                clearAfterDelay = true;
            }

            this.setState({ loading: false, error: errorMessage });

            if (clearAfterDelay) {
                setTimeout(() => {
                    this.setState({ error: "" });
                }, 10000); // 10 seconds
            }
        }
    };


    render() {
        const { firstName, lastName, email, password, phone, country, loading, error, success } = this.state



        return (
            <div className="registration_container">



                <section className="registration image">
                    <div className="style"></div>
                    <div className="style"></div>
                    <img src={Image} alt="register_image" />
                </section>






                <section className="registration content">

                    <header className="register_header">
                        <Link to="/"><img src={Logo} alt="logo" /></Link>
                    </header>


                    <div className="register_body">
                        <h2>Let’s Get You Started</h2>
                        <p>Start your journey with smart insights and powerful investment tools.</p>
                        <button className="google">Sign Up With Google</button>
                        <p>--- or ---</p>
                        <form onSubmit={this.handleSubmit}>
                            <div className="input_half">
                                <input onChange={this.handleInput} value={firstName} type="text" name="firstName" id="firstName" placeholder="First Name" required />
                                <input onChange={this.handleInput} value={lastName} type="text" name="lastName" id="lastName" placeholder="Last Name" required />
                            </div>
                            <div className="input_half">
                                <input onChange={this.handleInput} value={email} type="email" name="email" id="email" placeholder="Email" required />
                                <input onChange={this.handleInput} value={phone} type="tel" name="phone" id="phone" placeholder="Phone" required />
                            </div>
                            <div className="input_half">
                                <input onChange={this.handleInput} value={country} type="text" name="country" id="country" placeholder="Country" required />
                            </div>
                            <input onChange={this.handleInput} value={password} type="password" name="password" id="password" placeholder="Paswword" required />
                            <div className="input_half" style={{ justifyContent: "left" }}>
                                <input type="checkbox" className="checkbox" /><label> i agree to the GeoGIS Terms Of Service, and Privacy Policy.</label>
                            </div>
                            <button disabled={loading}>{loading ? "Loading" : "Submit"}</button>

                        </form>
                        {error && <p className="error">{error}</p>}
                        {success && <p className="error" style={{ color: "green" }}>{success}</p>}
                        <p>Already Have An Account? <Link to="/login"><span className="blue">Sign In</span></Link></p>

                    </div>


                    <footer className="register_footer">

                    </footer>



                </section>

            </div>
        )
    }
}



export default AdminSignup